import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../styles'
import { Radio, withStyles } from '@material-ui/core'
import clsx from 'clsx'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'

const useStyle = makeStyles((theme) => ({
	...styles(theme),
	icon: {
		borderRadius: '50%',
		width: 22,
		height: 22,
		boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
		backgroundColor: theme.palette.blue['10'],
		'input:hover ~ &': {
			backgroundColor: theme.palette.blue['20']
		}
	},
	checkedIcon: {
		backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
		'&:before': {
			display: 'block',
			width: 22,
			height: 22,
			backgroundImage: `radial-gradient(${theme.palette.accessibility.main},${theme.palette.accessibility.main} 30%,transparent 38%)`,
			content: '""'
		},
		'input:hover ~ &': {
			backgroundColor: theme.palette.blue['20']
		}
	}
}))

const CustomRadio = withStyles((theme) => ({
	root: {
		color: theme.palette.blue['10']
	},
	colorSecondary: {
		color: theme.palette.accessibility.main,
		'&$checked': {
			color: theme.palette.accessibility.main
		}
	},
	checked: {}
}))(Radio)

interface AcceptingProps {
	key?: string,
	label: string,
	value: string,
	textStyle: string,
	textColor: string,
	textWeight?: string
}

type FormControlLabelFieldProps = AcceptingProps

const FormControlLabelField: React.FC<FormControlLabelFieldProps> = (
	{
		key,
		label,
		value,
		textStyle,
		textColor,
		textWeight
	}
) => {
	const classes = useStyle()
	const optionClass: ClassValue = classNames(
		classes[textColor as keyof typeof styles],
		classes[textStyle as keyof typeof styles],
		classes[textWeight as keyof typeof styles]
	)
	return (
		<FormControlLabel
			key={key}
			classes={{
				label: optionClass
			}}
			value={value}
			control={
				<CustomRadio
					icon={
						<span className={classes.icon} />
					}
					checkedIcon={
						<span className={clsx(classes.icon, classes.checkedIcon)} />
					}
				/>
			}
			label={label}
		/>
	)
}
export default FormControlLabelField